import axios from "axios";

export const STORAGE_KEY = 'AC_API_API';

export const getACApi = () => {
    const data = localStorage.getItem(STORAGE_KEY);

    if (!data) {
        return null;
    };

    return JSON.parse(data);
}

export const getVoiceApi = () => getACApi()?.digital || process.env.REACT_APP_ServerBaseURL;

// Fetch Cognito config from backend API
export const fetchCognitoConfig = async () => {
    try {
        const baseUrl = getVoiceApi();
        const response = await axios.get(`${baseUrl}api/config/v1/`);

        if (response.data?.code === 'success' && response.data?.data) {
            const configItems = response.data.data;
            const config = {};

            // Map config items to cognito config object
            configItems.forEach(item => {
                if (item.configName === 'cognito.domain') {
                    config.domain = item.configValue;
                } else if (item.configName === 'cognito.clientId') {
                    config.clientId = item.configValue;
                } else if (item.configName === 'cognito.responseType') {
                    config.responseType = item.configValue;
                } else if (item.configName === 'cognito.scope') {
                    config.scope = item.configValue;
                }
            });

            // Validate required config values
            const missingFields = [];
            if (!config.domain) missingFields.push('cognito.domain');
            if (!config.clientId) missingFields.push('cognito.clientId');
            if (!config.responseType) missingFields.push('cognito.responseType');
            if (!config.scope) missingFields.push('cognito.scope');

            if (missingFields.length > 0) {
                throw new Error(`Missing required Cognito config: ${missingFields.join(', ')}`);
            }

            return config;
        }

        throw new Error('Failed to fetch Cognito config: Invalid response');
    } catch (error) {
        console.error('Failed to fetch Cognito config:', error);
        throw error;
    }
};
